import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Switch from '@material-ui/core/Switch';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Filter extends React.Component {
    state = {
        desechable: this.props.filtro.desechable,
        producible: this.props.filtro.producible,
        estacion: this.props.filtro.estacion,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleClose = (desechable, producible, estacion) => (event) => {
        this.props.handleClose({
            desechable: desechable,
            producible: producible,
            estacion: estacion,
        });
    };

    render() {
        const { desechable, producible, estacion } = this.state;
        const { intl, workstation } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="type_label_desechable" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'desechable'}
                                checked={desechable}
                                onChange={this.handleChecked}
                                value="desechable"
                                color="primary"
                            />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="type_label_producible" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'producible'}
                                checked={producible}
                                onChange={this.handleChecked}
                                value="producible"
                                color="primary"
                            />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_estacion' })}
                            </InputLabel>
                            <Select
                                native
                                value={estacion}
                                onChange={this.handleChange}
                                inputProps={{ name: 'estacion', id: 'estacion-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {workstation &&
                                    workstation.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.nombre}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(desechable, producible, estacion)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/products/FilterMenu.js